module.exports = __webpack_public_path__ + "static/media/closeMap.0175faa6.svg";